module.exports = __webpack_public_path__ + "img/mtb_road.65deebe9.jpg";